/**
 * config.ts — доступ к window.CART_CONFIG
 * Проект: TorgiRT (shared — все витрины)
 *
 * Листовой модуль без импортов — используется как auth.js, так и helpers.js.
 * Это позволяет auth-standalone.js (entry point для login-form.php)
 * подтянуть только config + auth (~2 КБ), не затрагивая state.js
 * и весь граф зависимостей основного бандла.
 */

import type { CartConfig } from './types';

/**
 * Получить значение из window.CART_CONFIG.
 */
export function getConfig<K extends keyof CartConfig>(
  key: K,
  fallback?: CartConfig[K]
): CartConfig[K] | undefined {
  const cfg = window.CART_CONFIG;
  return (cfg && cfg[key]) ?? fallback;
}
